import { HostListener, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';

import { Router } from '@angular/router';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const $, Swal;

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {
  value: any;
  requestDemoForm: FormGroup;
  submitted = false;
  errors:any= [];
  requestDemoModal=false;
primaryMenubarElem:any;

  

  constructor(
    public router: Router,
    public api: ApiService,
    public swal: SweetAlert,
    private formBuilder: FormBuilder
  ) { 
    
  }
  
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
  
    const currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
       
        this.primaryMenubarElem.classList.add("scroll-down");
      }else{
        this.primaryMenubarElem.classList.remove("scroll-down");
      }
    }
 
  ngOnInit() {
    // $('#nav > ul').dropotron({
    //   alignment: 'right'
    // });

    this.primaryMenubarElem =  document.querySelector("#primary-navbar");

    this.requestDemoForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      mobile: ['', [Validators.required, Validators.pattern('[0-9]\\d{9}')]],
      company: ['', Validators.required],
      country:  ['India', Validators.required],
  },);
  }
  ngAfterViewChecked() {
    // this.scrollToBottom();
}

onSubmit() {
  this.submitted = true;
  // console.log(this.requestDemoForm)

  // stop here if form is invalid
  if (this.requestDemoForm.invalid) {
      return;
  }
  
  this.errors = [];
  this.api.homepageRequestDemoForm({
    "email": this.requestDemoForm.value.email,
    "name": this.requestDemoForm.value.name,
    "mobile": this.requestDemoForm.value.mobile,
    "companyname": this.requestDemoForm.value.company,
     "country": this.requestDemoForm.value.country,
}).then((resp: any) => {
    // console.log(resp);
    if (resp && resp.status) {
        if (resp.status === "failure") {
            this.submitted = false;
            if (resp['message'] instanceof Array) {
                this.errors = resp['message'];
            } else {
                this.errors = [resp['message']];
            }
        } else if (resp.status === "success") {
          this.swal.swalFunction('success', resp.status, resp.message, 2000);
          this.router.navigate(['homepage']);       
             console.log("success")
         
        }
    } else this.errors = ["Unable to reach server"];
    
}).catch((error) => {
    console.error(error);
    this.errors = ["Unable to reach server"];
  });
  
}


onReset() {
  this.submitted = false;
  this.requestDemoForm.reset();
}

  
  employeeSolution(val) {
    this.value = val.target.value;
    console.log(val.target.value);
    if (this.value == 'Transport Manager Login') {
      this.router.navigate(['/transportmanager']);
    }
  }
  transportManagerLogin() {
    this.router.navigate(['/organization/transport-manager/login']);
  }
   

  scrollToBottom(){
 
    window.scrollTo(0, document.body.scrollHeight);
}

}




